import { useEffect, useState } from "react";

const RealtimeWaitingTime = ({ waitingSince }) => {
  const [now, setNow] = useState(Date.now());
  
  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // ⛔ guard: missing or invalid value
  if (!waitingSince || typeof waitingSince !== "number") {
    return <div className="small text-muted">—</div>;
  }

  const diff = Math.max(0, now - waitingSince);
  const minutes = Math.floor(diff / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);

  return (
    <div className="small text-muted">
      {minutes}m {seconds}s
    </div>
  );
};

export default RealtimeWaitingTime;
